/**
 * Tenants CopilotKit Suggestions
 * Smart chat hints for tenant management
 */

import { useCopilotChatSuggestions, useSelector } from '@ufc/core'
import { selectPendingTenantsCount, selectTenantsStats } from '../store/tenants.selectors'

export function useTenantsSuggestions() {
  const pendingCount = useSelector(selectPendingTenantsCount)
  const stats = useSelector(selectTenantsStats)

  useCopilotChatSuggestions({
    instructions: `
      Suggest helpful actions for tenant management based on current context:
      - There are ${pendingCount} pending tenants awaiting approval
      - Total tenants: ${stats.total}, Active: ${stats.active}, Suspended: ${stats.suspended}

      Possible suggestions:
      ${pendingCount > 0 ? '- "Show pending tenants for approval"' : ''}
      ${stats.suspended > 0 ? '- "Show suspended tenants"' : ''}
      - "Search for a tenant by name"
      - "Filter tenants by B2B channel"
      - "Filter tenants by ecommerce channel"
      - "Show all active tenants"
    `,
  })
}
